import * as React from 'react';

var _ref =
/*#__PURE__*/
React.createElement(React.Fragment, null, React.createElement("defs", null, React.createElement("style", null, ".calendar_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}")), React.createElement("rect", {
  className: "calendar_svg__a",
  x: 0.5,
  y: 2.501,
  width: 23,
  height: 21,
  rx: 1,
  ry: 1
}), React.createElement("path", {
  className: "calendar_svg__a",
  d: "M5.5.501v5M18.5.501v5M.5 7.501h23"
}));

var SvgCalendar = function SvgCalendar() {
  return _ref;
};

export default SvgCalendar;